<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        <div class="filters-row">
            <div class="filter-group contrato-filter">
                <div class="multi-select">
                    <div
                        class="multi-select-control"
                        :class="{
                            'is-open': dropdownContrato
                        }"
                        @click="toggleContratoDropdown"
                    >
                        <span
                            v-if="contratosSel.length === 0"
                            class="select-placeholder"
                        >
                            Seleccionar contratos
                        </span>
                        <span
                            v-else
                            class="select-value"
                        >
                            {{ contratosSel.length }}
                            seleccionado(s)
                        </span>
                        <span class="select-arrow">
                            {{ dropdownContrato ? '▲' : '▼' }}
                        </span>
                    </div>
                    <div
                        v-if="dropdownContrato"
                        class="multi-select-menu"
                        @click.stop
                    >
                        <!-- SELECCIONAR TODOS -->
                        <label
                            class="multi-select-option select-all-option"
                        >
                            <input
                                type="checkbox"
                                :checked="
                                    lstContratos.length > 0 &&
                                    contratosSel.length === lstContratos.length
                                "
                                @change="selAllChkContrato"
                            />
                            <span>
                                {{ labels.selectTodos }}
                            </span>
                        </label>
                        <div class="select-separator"></div>


                        <!-- LISTA DE CONTRATOS -->

                        <label
                            v-for="contrato in lstContratos"
                            :key="contrato.id"
                            class="multi-select-option"
                        >
                            <input
                                type="checkbox"
                                :value="contrato.nro_contrato"
                                v-model="contratosSel"
                                @change="selChkContrato"
                            />
                            <span>
                                {{ contrato?.nro_contrato }}
                            </span>
                        </label>

                        <!-- SIN DATOS -->
                        <div
                            v-if="lstContratos.length === 0"
                            class="no-options"
                        >
                            No hay contratos disponibles
                        </div>
                    </div>
                </div>
            </div>

            <!-- ================================================= -->
            <!-- ARRENDADOR -->
            <!-- ================================================= -->

            <div class="filter-group arrendador-filter">
                <!-- <label class="filter-label">
                    {{ labels.arrendador }}
                </label> -->
                <div class="multi-select">
                    <div
                        class="multi-select-control"
                        :class="{
                            'is-open': dropdownArrendador
                        }"
                        @click="toggleArrendadorDropdown"
                    >
                        <span
                            v-if="arrendadorSel.length === 0"
                            class="select-placeholder"
                        >
                            Seleccionar arrendadores
                        </span>
                        <span
                            v-else
                            class="select-value"
                        >
                            {{ arrendadorSel.length }}
                            seleccionado(s)
                        </span>
                        <span class="select-arrow">
                            {{ dropdownArrendador ? '▲' : '▼' }}
                        </span>
                    </div>
                    <div
                        v-if="dropdownArrendador"
                        class="multi-select-menu"
                        @click.stop
                    >

                        <!-- SELECCIONAR TODOS -->
                        <label
                            class="multi-select-option select-all-option"
                        >
                            <input
                                type="checkbox"
                                :checked="
                                    lstArrendador.length > 0 &&
                                    arrendadorSel.length === lstArrendador.length
                                "
                                @change="selAllChkArrendador"
                            />
                            <span>
                                {{ labels.selectTodos }}
                            </span>
                        </label>

                        <div class="select-separator"></div>

                        <!-- LISTA DE ARRENDADORES -->

                        <label
                            v-for="arrendador in lstArrendador"
                            :key="arrendador.id"
                            class="multi-select-option"
                        >
                            <input
                                type="checkbox"
                                :value="arrendador.identificacion"
                                v-model="arrendadorSel"
                                @change="selChkArrendador"
                            />
                            <span>
                                {{ arrendador?.nombre }}
                            </span>

                        </label>
                        <div
                            v-if="lstArrendador.length === 0"
                            class="no-options"
                        >
                            No hay arrendadores disponibles
                        </div>
                    </div>
                </div>
            </div>
            <div class="consult-button-container">
                <b-button
                    class="consult-btn ml-2"
                    @click="consultaReporte()"
                    :disabled="
                        contratosSel.length === 0 &&
                        arrendadorSel.length === 0
                    "
                >
                    <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                    {{ labels.consultar }}
                </b-button>
            </div>
        </div>


        <!-- ===================================================== -->
        <!-- REPORTE -->
        <!-- ===================================================== -->

        <div class="report-container">

            <!-- <h3 v-if="tituloReporte">
                {{ tituloReporte }}
            </h3> -->
            <div class="admin-table-block mt-4">
                <div>
                    <CorporateDataTable
                    :items="lstActContrato"
                    :fields="allFieldsAct"
                    :labels="tableLabelsAct"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                    >
                        <template #toolbar-actions>
                            <div class="niif-toolbar-right">
                                <b-button
                                size="sm"
                                class="table-toolbar-excel-btn"
                                @click="generaReporteActivos()"
                                :disabled="!showToolbarExtras || lstActContrato.length === 0"
                                >
                                <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                                </b-button>
                            </div>
                        </template>
                        <template #cell(valor_compra)="data">
                            <div class="text-right">{{ formatNumber(data.item.valor_compra) }}</div>
                        </template>
                        <template #cell(valor_salvamento)="data">
                            <div class="text-right">{{ formatNumber(data.item.valor_salvamento) }}</div>
                        </template>                        
                    </CorporateDataTable>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import Contrato from '../../services/Contrato';
import Tercero from '../../services/Tercero';
import Reportes from '../../services/Reportes';
import Authentication from "../../services/Authentication";
import CorporateDataTable from '../utils/CorporateDataTable.vue';
import * as XLSX from "exceljs";

export default {
    name: 'ActivosPorContrato',
    components: {CorporateDataTable},
    data: () => ({
        lstContratos: [],
        contratosSel: [],
        dropdownContrato: false,
        lstArrendador: [],
        arrendadorSel: [],
        dropdownArrendador: false,
        lstActContrato: [],
        nameCompania: '',
        btnGenExcel: false,
        showToolbarExtras: false,
        tituloReporte: '',
        // =====================================================
        // PAGINACIÓN
        // =====================================================
        perPage: 20,
        currentPage: 1,

        // =====================================================
        // CAMPOS TABLA POR ARRENDADOR
        // =====================================================

        field: [

            {
                key: 'arrendador',
                label: 'Arrendador',
                sortable: false
            },

            {
                key: 'nro_contrato',
                label: 'Contrato',
                sortable: false
            },

            {
                key: 'tipo_activo',
                label: 'Tipo activo',
                sortable: false
            },

            {
                key: 'descripcion',
                label: 'Descripción',
                sortable: false
            },

            {
                key: 'valor_compra',
                label: 'Valor compra',
                sortable: false
            },

            {
                key: 'valor_salvamento',
                label: 'Valor salvamento',
                sortable: false
            },

            {
                key: 'fecha_compra',
                label: 'Fecha compra',
                sortable: false
            }

        ]

    }),


    // =========================================================
    // COMPUTED
    // =========================================================

    computed: {
        labels() {
            if (
                this.$store.state._language === "es-ES"
            ) {
                return {
                    title: 'Reporte por activos',
                    consultar: 'Consultar',
                    contrato: 'Contrato',
                    arrendador: 'Arrendador',
                    arrendado: 'Arrendador',
                    fecha: 'Fecha',
                    nro_contrato: 'Contrato',
                    tipo_activo: 'Tipo activo',
                    descripcion: 'Descripción',
                    valor_compra: 'Valor compra',
                    valor_salvamento: 'Valor salvamento',
                    fecha_compra: 'Fecha compra',
                    filterContrato: 'Filtrar contrato...',
                    filterArrendador: 'Filtrar arrendador...',
                    filterTipoActivo: 'Filtrar tipo activo...',
                    filterDescripcion: 'Filtrar descripción...',
                    filterValCompra: 'Filtrar valor compra...',
                    filterValSalvamento: 'Filtrar valor salvamento...',
                    filterfechaCompra: 'Filtrar fecha compra...',
                    selectTodos: 'Seleccionar todos'
                };

            } else {
                return {
                    title: 'Asset report',
                    consultar: 'Consult',
                    contrato: 'Contract',
                    arrendador: 'Lessor',
                    arrendado: 'Lessor',
                    fecha: 'Date',
                    nro_contrato: 'Contract',
                    tipo_activo: 'Asset type',
                    descripcion: 'Description',
                    valor_compra: 'Purchase value',
                    valor_salvamento: 'Salvage value',
                    fecha_compra: 'Purchase date',
                    filterContrato: 'Filter contract...',
                    filterArrendador: 'Filter landlord...',
                    filterTipoActivo: 'Filter asset type...',
                    filterDescripcion: 'Filter description...',
                    filterValCompra: 'Filter purchase value...',
                    filterValSalvamento: 'Filter salvage value...',
                    filterfechaCompra: 'Filter by purchase date...',
                    selectTodos: 'Select all'
                };
            }
        },
        allFieldsAct() {
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center text-nowrap', tdClass: 'text-center align-middle text-nowrap'},
                { key: 'arrendador', label: this.labels.arrendador, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-left align-middle text-nowrap'} ,
                { key: 'tipo_activo', label: this.labels.tipo_activo, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-start align-middle text-nowrap'},
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-start align-middle text-nowrap'},
                { key: 'valor_compra', label: this.labels.valor_compra, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-end align-middle text-nowrap'},
                { key: 'valor_salvamento', label: this.labels.valor_salvamento, thClass: 'text-center text-nowrap', tdClass: 'text-end align-middle text-nowrap', sortable: false},
                { key: 'fecha_compra', label: this.labels.fecha_compra, thClass: 'text-center text-nowrap', tdClass: 'text-center align-middle text-nowrap', sortable: false}
            ]
        },
        allFieldsArr() {
            return [
                { key: 'arrendador', label: this.labels.arrendador, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-left align-middle text-nowrap' } ,
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center text-nowrap', tdClass: 'text-center align-middle text-nowrap' },
                { key: 'tipo_activo', label: this.labels.tipo_activo, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-start align-middle text-nowrap' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-start align-middle text-nowrap' },
                { key: 'valor_compra', label: this.labels.valor_compra, sortable: true, thClass: 'text-left text-nowrap', tdClass: 'text-end align-middle text-nowrap' },
                { key: 'valor_salvamento', label: this.labels.valor_salvamento, thClass: 'text-center text-nowrap', tdClass: 'text-end align-middle text-nowrap', sortable: false },
                { key: 'fecha_compra', label: this.labels.fecha_compra, thClass: 'text-center text-nowrap', tdClass: 'text-center align-middle text-nowrap', sortable: false }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'arrendador', type: 'text', placeholder: this.labels.filterArrendador },
                { key: 'tipo_activo', type: 'text', placeholder: this.labels.filterTipoActivo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion },
                { key: 'valor_compra', type: 'text', placeholder: this.labels.filterValCompra },
                { key: 'valor_salvamento', type: 'text', placeholder: this.labels.filterValSalvamento },
                { key: 'fecha_compra', type: 'text', placeholder: this.labels.filterfechaCompra }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        showSearchTable() {
            return true
        }
    },


    // =========================================================
    // METHODS
    // =========================================================

    methods: {

        goBack(){
            this.$router.back()
        },

        // =====================================================
        // ABRIR DROPDOWN CONTRATO
        // =====================================================

        toggleContratoDropdown() {

            this.dropdownContrato =
                !this.dropdownContrato;


            if (this.dropdownContrato) {

                this.dropdownArrendador = false;

            }

        },


        // =====================================================
        // ABRIR DROPDOWN ARRENDADOR
        // =====================================================

        toggleArrendadorDropdown() {

            this.dropdownArrendador =
                !this.dropdownArrendador;


            if (this.dropdownArrendador) {

                this.dropdownContrato = false;

            }

        },


        // =====================================================
        // SELECCIONAR CONTRATO
        // =====================================================

        selChkContrato() {

            // Si se selecciona contrato,
            // se elimina la selección de arrendadores.

            this.arrendadorSel = [];


            // Limpiar resultado anterior

            this.lstActContrato = [];

            this.btnGenExcel = false;

            this.tituloReporte = '';

            this.currentPage = 1;

        },


        // =====================================================
        // SELECCIONAR TODOS LOS CONTRATOS
        // =====================================================

        selAllChkContrato() {

            if (
                this.lstContratos.length > 0 &&
                this.contratosSel.length ===
                this.lstContratos.length
            ) {

                // Deseleccionar todos

                this.contratosSel = [];

            } else {

                // Seleccionar todos

                this.contratosSel =
                    this.lstContratos.map(
                        contrato =>
                            contrato.nro_contrato
                    );

            }


            // Limpiar arrendadores

            this.arrendadorSel = [];


            // Limpiar reporte

            this.lstActContrato = [];

            this.btnGenExcel = false;

            this.tituloReporte = '';

            this.currentPage = 1;

        },


        // =====================================================
        // SELECCIONAR ARRENDADOR
        // =====================================================

        selChkArrendador() {

            // Si se selecciona arrendador,
            // se eliminan los contratos.

            this.contratosSel = [];


            // Limpiar reporte

            this.lstActContrato = [];

            this.btnGenExcel = false;

            this.tituloReporte = '';

            this.currentPage = 1;

        },


        // =====================================================
        // SELECCIONAR TODOS LOS ARRENDADORES
        // =====================================================

        selAllChkArrendador() {

            if (
                this.lstArrendador.length > 0 &&
                this.arrendadorSel.length ===
                this.lstArrendador.length
            ) {

                // Deseleccionar todos

                this.arrendadorSel = [];

            } else {

                // Seleccionar todos

                this.arrendadorSel =
                    this.lstArrendador.map(
                        arrendador =>
                            arrendador.identificacion
                    );

            }


            // Limpiar contratos

            this.contratosSel = [];


            // Limpiar reporte

            this.lstActContrato = [];

            this.btnGenExcel = false;

            this.tituloReporte = '';

            this.currentPage = 1;

        },


        // =====================================================
        // CONSULTAR REPORTE
        // =====================================================

        consultaReporte() {

            // =================================================
            // POR CONTRATO
            // =================================================
            this.dropdownContrato = false;
            if (
                this.contratosSel.length !== 0
            ) {

                this.tituloReporte =
                    'Activos por Contrato';


                Reportes.getActivosPorContract(this.contratosSel)
                .then((res) => {

                    this.lstActContrato =res.data.result || [];

                    this.currentPage = 1;

                    if (this.lstActContrato.length !== 0) {
                        this.showToolbarExtras = true;
                    }

                })
                .catch((err) => {

                    console.log(err);

                    this.lstActContrato = [];

                    this.btnGenExcel = false;

                });
            }


            // =================================================
            // POR ARRENDADOR
            // =================================================

            else if (
                this.arrendadorSel.length !== 0
            ) {

                this.tituloReporte = 'Activos por Arrendador';
                this.dropdownArrendador = false;


                Reportes.getActivosPorArrendad(this.arrendadorSel)
                .then((res) => {

                    this.lstActContrato = res.data.result || [];
                    this.currentPage = 1;

                    if (this.lstActContrato.length !== 0) {
                        this.showToolbarExtras = true;
                    }
                })
                .catch((err) => {

                    console.log(err);
                    this.lstActContrato = [];
                });
            }

        },


        // =====================================================
        // GENERAR EXCEL
        // =====================================================

        async generaReporteActivos() {

            const { Workbook } = XLSX;


            const workbook =
                new Workbook();


            const worksheet =
                this.tituloReporte ===
                'Activos por Arrendador'

                    ? workbook.addWorksheet(
                        "Lista de activos por arrendador"
                    )

                    : workbook.addWorksheet(
                        "Lista de activos por contrato"
                    );


            // =================================================
            // TÍTULO
            // =================================================

            const titulo =
                this.tituloReporte ===
                'Activos por Arrendador'

                    ? ['Lista de activos por arrendador']

                    : ['Lista de activos por contrato'];


            worksheet.addRow(titulo);

            worksheet.mergeCells('A1:G1');


            worksheet.getCell('A1').font = {

                name: 'Arial',

                bold: true,

                size: 12

            };


            worksheet.getCell('A1').alignment = {

                horizontal: 'center'

            };


            // =================================================
            // FILA 2
            // =================================================

            worksheet.addRow(['']);

            worksheet.mergeCells('A2:G2');


            const cell2 =
                worksheet.getCell('A2');


            cell2.value = {

                richText: [

                    {
                        text: 'Generado por: ',
                        font: {
                            bold: true
                        }
                    },

                    {
                        text:
                            `${this.$store.state.userName} | `
                    },

                    {
                        text: 'Fecha generación: ',
                        font: {
                            bold: true
                        }
                    },

                    {
                        text:
                            `${this.fechaActual()} | `
                    },

                    {
                        text: 'Compañía: ',
                        font: {
                            bold: true
                        }
                    },

                    {
                        text:
                            `${this.nameCompania}`
                    }

                ]

            };


            cell2.font = {

                name: 'Arial',

                size: 12

            };


            cell2.alignment = {

                horizontal: 'center',

                vertical: 'middle'

            };


            // =================================================
            // FILA 3
            // =================================================

            worksheet.addRow(['']);

            worksheet.mergeCells('A3:G3');


            let tituloCelda = [];


            if (
                this.tituloReporte ===
                'Activos por Arrendador'
            ) {

                tituloCelda = [

                    'Arrendador',

                    'Contrato',

                    'Tipo activo',

                    'Descripción',

                    'Valor compra',

                    'Valor salvamento',

                    'Fecha compra'

                ];

            } else {

                tituloCelda = [

                    'Contrato',

                    'Arrendador',

                    'Tipo activo',

                    'Descripción',

                    'Valor compra',

                    'Valor salvamento',

                    'Fecha compra'

                ];

            }


            const headerRow =
                worksheet.addRow(
                    tituloCelda
                );


            headerRow.font = {

                name: 'Arial',

                bold: true,

                size: 12

            };


            headerRow.alignment = {

                horizontal: 'center'

            };


            // =================================================
            // DATOS
            // =================================================

            this.lstActContrato.forEach(
                (e) => {

                    worksheet.addRow([

                        this.tituloReporte ===
                        'Activos por Arrendador'

                            ? e.arrendador
                            : e.nro_contrato,

                        this.tituloReporte ===
                        'Activos por Arrendador'

                            ? e.nro_contrato
                            : e.arrendador,

                        e.tipo_activo,

                        e.descripcion,

                        this.formatNumber(
                            e.valor_compra
                        ),

                        this.formatNumber(
                            e.valor_salvamento
                        ),

                        e.fecha_compra

                    ]);

                }
            );


            // =================================================
            // BORDES
            // =================================================

            const border = {

                top: {
                    style: 'thin'
                },

                left: {
                    style: 'thin'
                },

                bottom: {
                    style: 'thin'
                },

                right: {
                    style: 'thin'
                }

            };


            for (
                let row = 1;
                row <= worksheet.rowCount;
                row++
            ) {

                if (
                    [1, 2, 3].includes(row)
                ) {

                    continue;

                }


                for (
                    let col = 1;
                    col <= worksheet.columnCount;
                    col++
                ) {

                    worksheet.getCell(
                        row,
                        col
                    ).border = border;

                }

            }


            // =================================================
            // DESCARGAR
            // =================================================

            const file =
                await workbook.xlsx.writeBuffer();


            const downloadLink =
                document.createElement('a');


            downloadLink.download =
                this.tituloReporte ===
                'Activos por Arrendador'

                    ? 'Lista de activos por arrendador.xlsx'

                    : 'Lista de activos por contrato.xlsx';


            downloadLink.href =
                window.URL.createObjectURL(

                    new Blob(
                        [file],
                        {
                            type:
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    )

                );


            downloadLink.style.display =
                'none';


            document.body.appendChild(
                downloadLink
            );


            downloadLink.click();


            downloadLink.remove();

        },


        // =====================================================
        // FORMATEAR NÚMERO
        // =====================================================

        formatNumber(valor) {

            return Intl.NumberFormat(
                'es-CO',
                {
                    maximumFractionDigits: 3,
                    minimumFractionDigits: 0
                }
            ).format(valor);

        },


        // =====================================================
        // FECHA ACTUAL
        // =====================================================

        fechaActual() {

            const fecha =
                new Date();


            const año =
                fecha.getFullYear();


            const mes =
                String(
                    fecha.getMonth() + 1
                ).padStart(2, '0');


            const dia =
                String(
                    fecha.getDate()
                ).padStart(2, '0');


            return `${año}-${mes}-${dia}`;

        }

    },


    // =========================================================
    // MOUNTED
    // =========================================================

    mounted() {

        // =====================================================
        // CONTRATOS
        // =====================================================

        Contrato.getAllContratos()

            .then((res) => {

                this.lstContratos =
                    res.data.listContratos || [];

            })

            .catch((err) => {

                console.log(err);

            });


        // =====================================================
        // ARRENDADORES
        // =====================================================

        Tercero.getAllTercero()

            .then((res) => {

                this.lstArrendador =
                    res.data.listTercero || [];

            })

            .catch((err) => {

                console.log(err);

            });


        // =====================================================
        // PARÁMETROS
        // =====================================================

        Authentication.leaParametros()

            .then((result) => {

                this.nameCompania =
                    result.data.parametros.compania;

            })

            .catch((err) => {

                console.log(err);

            });

    }

};

</script>


<style scoped>

/* ========================================================= */
/* CONTENEDOR PRINCIPAL */
/* ========================================================= */

.admin-table-page {
    padding-top: 5px;
}


/* ========================================================= */
/* TÍTULO */
/* ========================================================= */

.report-title {

    display: flex;

    align-items: center;

    gap: 10px;

    margin-top: 5px;

    margin-bottom: 28px;

}


.report-title h2 {

    margin: 0;

    color: #1f4668;

    font-size: 30px;

    font-weight: 500;

}


.back-icon {

    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;

}


/* .back-icon:hover {

    background-color: #014f70;

    transform: translateX(-2px);

} */


/* ========================================================= */
/* FILA DE FILTROS */
/* ========================================================= */

.filters-row {
    width: 100%;
    display: flex;
    align-items: flex-end;
    gap: 16px;
    padding: 10px 40px;
}


/* ========================================================= */
/* GRUPOS */
/* ========================================================= */

.filter-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.contrato-filter {
    width: 310px;
}

.arrendador-filter {
    width: 310px;
}

/* ========================================================= */
/* LABELS */
/* ========================================================= */

.filter-label {
    margin: 0;
    white-space: nowrap;
    color: #1f4668;
    font-size: 16px;
    font-weight: 500;
}


/* ========================================================= */
/* MULTISELECT */
/* ========================================================= */

.multi-select {
    position: relative;
    width: 100%;
}


/* ========================================================= */
/* CONTROL DEL SELECT */
/* ========================================================= */

.multi-select-control {
    height: 38px;
    background: #ffffff;
    border: 1px solid #d5dce2;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    cursor: pointer;
    font-size: 14px;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
}


.multi-select-control:hover {

    border-color: #9aabb8;

}


.multi-select-control.is-open {

    border-color: #016690;

    box-shadow:
        0 0 0 2px rgba(
            1,
            102,
            144,
            0.10
        );

}


/* ========================================================= */
/* TEXTO DEL SELECT */
/* ========================================================= */

.select-placeholder {

    color: #9aa3ab;

}


.select-value {

    color: #334e68;

    font-weight: 500;

}


.select-arrow {

    margin-left: 10px;

    color: #6c757d;

    font-size: 9px;

}


/* ========================================================= */
/* DROPDOWN */
/* ========================================================= */

.multi-select-menu {

    position: absolute;

    top: calc(100% + 5px);

    left: 0;

    width: 100%;

    max-height: 250px;

    overflow-y: auto;

    background: #ffffff;

    border: 1px solid #d5dce2;

    border-radius: 7px;

    box-shadow:
        0 5px 15px
        rgba(0, 0, 0, 0.15);

    z-index: 2000;

    padding: 5px 0;

}


/* ========================================================= */
/* OPCIONES */
/* ========================================================= */

.multi-select-option {

    display: flex;

    align-items: center;

    gap: 10px;

    width: 100%;

    padding: 8px 12px;

    margin: 0;

    cursor: pointer;

    font-size: 14px;

    color: #34495e;

    transition:
        background-color 0.15s ease;

}


.multi-select-option:hover {

    background-color: #f3f7fa;

}


/* ========================================================= */
/* CHECKBOX */
/* ========================================================= */

.multi-select-option input[type="checkbox"] {

    width: 16px;

    height: 16px;

    margin: 0;

    cursor: pointer;

    accent-color: #016690;

}


/* ========================================================= */
/* SELECCIONAR TODOS */
/* ========================================================= */

.select-all-option {

    font-weight: 600;

    color: #1f4668;

}


/* ========================================================= */
/* SEPARADOR */
/* ========================================================= */

.select-separator {

    height: 1px;

    background-color: #e8edf1;

    margin: 4px 10px;

}


/* ========================================================= */
/* SIN DATOS */
/* ========================================================= */

.no-options {

    padding: 12px;

    text-align: center;

    color: #8a969f;

    font-size: 13px;

}


/* ========================================================= */
/* SCROLL */
/* ========================================================= */

.multi-select-menu::-webkit-scrollbar {

    width: 6px;

}


.multi-select-menu::-webkit-scrollbar-track {

    background: transparent;

}


.multi-select-menu::-webkit-scrollbar-thumb {

    background: #c8d0d6;

    border-radius: 10px;

}


.multi-select-menu::-webkit-scrollbar-thumb:hover {

    background: #aab5bd;

}


/* ========================================================= */
/* BOTÓN CONSULTAR */
/* ========================================================= */
/*
.consult-button-container {

    display: flex;

    align-items: center;

    margin-left: auto;

}


.consult-button {

    height: 38px;

    min-width: 125px;

    border: none !important;

    border-radius: 7px !important;

    background-color: #016690 !important;

    color: #ffffff !important;

    font-weight: 600;

    font-size: 14px;

    display: flex;

    align-items: center;

    justify-content: center;

    gap: 7px;

    transition: all 0.2s ease;

}


.consult-button:hover:not(:disabled) {

    background-color: #014f70 !important;

    transform: translateY(-1px);

}


.consult-button:disabled {

    background-color: #aeb7bd !important;

    color: #ffffff !important;

    cursor: not-allowed;

    opacity: 0.8;

}
*/

/* ========================================================= */
/* REPORTE */
/* ========================================================= */

.report-container {

    width: 100%;

    margin-top: 35px;

}


.report-container h3 {

    color: #1f4668;

    font-size: 22px;

    font-weight: 500;

    margin-bottom: 15px;

}


/* ========================================================= */
/* EXCEL */
/* ========================================================= */

.excel-container {

    display: flex;

    justify-content: flex-end;

    margin-bottom: 10px;

}


.excel-button {

    width: 40px;

    height: 40px;

    padding: 8px !important;

    background-color: #2e507a !important;

    border: none !important;

    border-radius: 6px !important;

}


.excel-button:hover {

    background-color: #244263 !important;

}


.excel-button svg {

    width: 24px;

    height: 24px;

}


/* ========================================================= */
/* TABLA */
/* ========================================================= */

.table-container {

    width: 100%;

}


/* ========================================================= */
/* PAGINACIÓN */
/* ========================================================= */

.pagination-container {

    width: 100%;

    display: flex;

    align-items: center;

    margin-top: 10px;

}


.pagination-center {

    width: 80%;

    display: flex;

    justify-content: center;

}


.rows-container {

    width: 20%;

    display: flex;

    align-items: center;

    justify-content: flex-end;

    gap: 8px;

}


.rows-container label {

    margin: 0;

    white-space: nowrap;

    font-size: 13px;

}


.rows-select {

    width: 80px;

}

.table-toolbar-excel-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #016690;
    color: white;
    border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
    background-color: #085170;
    border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}


/* ========================================================= */
/* RESPONSIVE */
/* ========================================================= */

@media (max-width: 1100px) {

    .filters-row {

        flex-wrap: wrap;

    }


    .contrato-filter {

        width: 45%;

    }


    .arrendador-filter {

        width: 45%;

    }


    /* .consult-button-container {

        margin-left: 0;

    } */

}


@media (max-width: 700px) {

    .report-title h2 {

        font-size: 24px;

    }


    .filters-row {

        flex-direction: column;

        align-items: stretch;

        gap: 15px;

    }


    .filter-group {

        width: 100% !important;

    }


    /* .consult-button-container {

        width: 100%;

        margin-left: 0;

    } */


    /* .consult-button {

        width: 100%;

    } */


    .pagination-container {

        flex-direction: column;

        gap: 10px;

    }


    .pagination-center,

    .rows-container {

        width: 100%;

        justify-content: center;

    }

}

</style>